import * as constants from './constants';
// import store from '../store';

// sets the the params of a target url into redux
export const setTargetParams = (params) => ({ type: constants.SET_TARGET_PROCESS, params });

// sets the distribution list object into redux
export const setFetchedDistributionList = (distributionList) => ({ type: constants.SET_FETCHED_DISTRIBUTION_LIST, distributionList });

// sets the study object into redux
export const setFetchedGroup = (group) => ({ type: constants.SET_FETCHED_GROUP, group });

export const setFetchedPanel = (panel) => ({ type: constants.SET_FETCHED_PANEL, panel });

// sets the study panel segment into redux
export const setFetchedGroupPanelSegment = (groupPanelSegment) => ({ type: constants.SET_FETCHED_GROUP_PANEL_SEGMENT, groupPanelSegment });

// sets the episode object into redux
export const setFetchedEpisode = (episode) => ({ type: constants.SET_FETCHED_EPISODE, episode });

// sets logged user into redux (token should not be saved)
export const setCurrentUser = (currentUser) => ({ type: constants.SET_CURRENT_USER, currentUser });

// sets logged user into redux (token should not be saved)
export const setCurrentUserLocation = (location) => ({ type: constants.SET_CURRENT_USER_LOCATION, location });

// sets logged user into redux (token should not be saved)
export const setUserMonitor = (userMonitor) => ({ type: constants.SET_USER_MONITOR, userMonitor });

export const setActivityList = (activityList) => ({ type: constants.SET_ACTIVITY_LIST, activityList });
export const invalidateActivityList = () => ({ type: constants.INVALIDATE_ACTIVITY_LIST });
export const setMyList = (myList) => ({ type: constants.SET_MY_LIST, myList });
export const invalidateMyList = () => ({ type: constants.INVALIDATE_MY_LIST });
export const addStudyToMyList = (study) => ({ type: constants.ADD_STUDY_TO_MY_LIST, study });

export const setPilotlyPoints = (pointTotal) => ({ type: constants.SET_PILOTLY_POINTS, pointTotal });
export const storeGoogleAnalyticsTracker = tracker => ({ type: constants.STORE_GA_TRACKER, tracker });

export const setUserDisclaimer = (userDisclaimer) => ({ type: constants.SET_USER_DISCLAIMER, userDisclaimer });

export const setPanelPartner = (partner) => ({ type: constants.SET_PANEL_PARTNER, partner });

// tech check
export const setTechCheckSpeakerTestAnswer = (answer) => ({ type: constants.SET_TECH_CHECK_SPEAKER_TEST_ANSWER, answer });
export const setTechCheckPlaybackTestAnswer = (answer) => ({ type: constants.SET_TECH_CHECK_PLAYBACK_TEST_ANSWER, answer });
export const setTechCheckConnectionResult = (result) => ({ type: constants.SET_TECH_CHECK_CONNECTION_RESULT, result });
export const setTechCheckConnectionSpeedResult = (result) => ({ type: constants.SET_TECH_CHECK_CONNECTION_SPEED_RESULT, result });
export const setTechCheckFinishedStatus = (status) => ({ type: constants.SET_TECH_CHECK_FINISHED_STATUS, status });

// sets hardware permission status based on the navigator API
export const setNavigatorAudioPermission = (audioPermission) => ({ type: constants.SET_NAVIGATOR_AUDIO_PERMISSIONS, audioPermission });
export const setWaitingForPermission = (waiting) => ({ type: constants.SET_WAITING_FOR_PERMISSION, waiting });



// WEBPACK FOOTER //
// ./src/redux/actions/index.js